import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import PhproductDashboard from '../PhproductDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function PhproductPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < PhproductDashboard />
    )

}